
import $ from 'jquery';

import {showError, hideError, setInputState, CustomError as AddressError } from './../../general/Error.js';
import {asyncValidateAll} from "../CheckoutUtil";

class VerifyAdressClass {

	dirty = true;
	checked = false;

	constructor( fieldsetEl ) {

		this.fieldsetEl = fieldsetEl;
		this.formEl = fieldsetEl.form;

		// Set addr dirty on any change.
		[...this.fieldsetEl.elements].forEach( inputEl => {
			inputEl.addEventListener( 'input', () => this.onChange() );
			inputEl.addEventListener( 'change', () => this.onChange() );
		} );

		// Verify when we click on the Google Autocomplete option.
		this.fieldsetEl.addEventListener( 'autocomplete_street.acl', () => this.maybeVerify() );

		const inputEls = this.fieldsetEl.querySelectorAll( '.acl_input--address' );
		inputEls.forEach( inputEl => {
			inputEl.addEventListener( 'focusout', () => this.maybeVerify() );
		})
	}

	onChange() {
		this.dirty = true;
	}

	maybeVerify() {
		clearTimeout( this.verifyTimeout );
		this.verifyTimeout = setTimeout( () => {
			const inputEls = Array.from( this.fieldsetEl.querySelectorAll( '.acl_input--address' ) );
			// If each Input El has a valid value, we trigger the verifícation.
			if ( inputEls.every( inputEl => inputEl.value && inputEl.checkValidity() ) ) {
				this.verify( true );
			}
		}, 100 );
	}

	verify( force = false ) {
		const formEl = this.formEl;
		const fieldsetEl = this.fieldsetEl;

		if ( fieldsetEl.disabled ) {
			return true;
		}

		const isPackstation = formEl.querySelector( '[id^=register_invoice_2_deliverypackingstation]' )?.matches( ':checked' );
		if ( isPackstation ) {
			return true;
		}

		if ( force ) {
			this.dirty = true;
		}

		// Form did not change since the last check.
		if ( ! this.dirty && this.checked ) {
			return true;
		}

		this.dirty = false;
		this.checked = false;

		// The element we are most concerned with.
		const streetInputEl = fieldsetEl.querySelector( '.acl_input--street_and_number' );
		setInputState( streetInputEl, 'loading' );

		return this.#sendRequest()
			.then( response => {
				const status = response['status'];

				// success - add packingstation input
				if ( 'pac' in response ) {
					const [ field ] = this.getFormSettings();
					const pacInputEl = this.fieldsetEl.querySelector( '.acl_input--pac-input' ) || document.createElement( 'input' )

					pacInputEl.name = `${field}[pac]`;
					pacInputEl.type = 'hidden';
					pacInputEl.value = response['pac'];
					pacInputEl.classList.add( 'acl_input--pac-input' );

					// Append to DOM if not connected.
					if ( ! pacInputEl.isConnected ) {
						this.fieldsetEl.appendChild( pacInputEl );
					}
				}

				if ( status.indexOf( 'OK' ) === 0 ) {

					// Address is OK - resolve truthy.´
					this.checked = true;
					this.dirty = false;
					return true;
				}

				// Streetname is too long.
				if ( status.indexOf( 'LNOK' ) === 0 ) {

					// Streetname is Not Ok.
					throw new AddressError( streetInputEl, 'Der Straßenname darf nicht länger als 35 Zeichen sein!' );
				}

				// Address could not be confirmed, but may work anyway - user can submit.
				if ( status.indexOf( 'ERROR' ) === 0 || status.indexOf( 'NOK' ) === 0 ) {

					// Resolve truthy on next submit.
					this.checked = true;
					this.dirty = false;

					// Error checking Adress. It may be OK.
					throw new AddressError( streetInputEl, 'Die angegebene Adresse konnte nicht bestätigt werden. Bitte prüfen Sie diese nochmals und setzen Sie anschließend mit „Weiter“ fort.', 'warning' );
				}

				try {
					// Automatically update Address - let the User know.
					for ( let key in response ) {

						let inputEl = formEl.elements[ key ];
						inputEl.value = response[ key ];

						showError( inputEl, 'Ihre Adresse wurde korrigiert. Bitte überprüfen Sie den Adressvorschlag.', 'warning' );
					}

					// Update Street and Number Field after changing the values.
					const street = fieldsetEl.querySelector( '.acl_input--street_name' ).value;
					const number = fieldsetEl.querySelector( '.acl_input--street_number' ).value;
					streetInputEl.value = street + ' ' + number;

					// Resolve truthy on next submit.
					this.checked = true;

					// Address did not change by user - we did that to ourselves.
					this.dirty = false;

					// Reject without any further Message.
					return false;

				} catch (err) {

					// Resolve truthy on next submit.
					this.checked = true;
					this.dirty = false;

					// Error checking Address. It may be OK.
					throw new AddressError( streetInputEl, 'Die angegebene Adresse konnte nicht bestätigt werden. Bitte prüfen Sie diese nochmals und setzen Sie anschließend mit „Weiter“ fort.', 'warning' );
				}

			})
			.catch( error => {

				// Handle Error display.
				if ( error instanceof AddressError ) {
					// Deconstruct and show error.
					error.show();
					return false;
				}

				// Any other error - log and return false.
				console.error( error );
				return false;
			}).then( ( ret ) => {

				// At the end, set the Input State of the streetinput.
				const wrapperEl = streetInputEl.closest( '.input_wrapper' );
				if ( 'loading' === wrapperEl.dataset.state ) {
					setInputState( streetInputEl, ret ? 'success' : 'error' );
				}

				return ret;
			} );
	}

	getFormSettings() {
		const type = this.formEl.dataset.addressType || 'billing';

		if ( 'shipping' === type ) {
			return [ 'deladr', 'oxaddress__', type];
		}

		return [ 'invadr', 'oxuser__', type ];
	}

	getFormData() {

		const data = $( this.formEl ).serializeJSON();

		// Get Field and Prefix to load correct data from values.
		const [ field, prefix, type ] = this.getFormSettings();

		// Map Data with corresponding fields.
		const email       = data[ field ][ prefix + 'oxusername' ] || data[ 'lgn_usr' ];
		const persontitle = data[ field ][ prefix + 'customtitle' ];
		const firstname   = data[ field ][ prefix + 'oxfname' ];
		const lastname    = data[ field ][ prefix + 'oxlname' ];
		const birthday    = '';
		const zipcode     = data[ field ][ prefix + 'oxzip' ];
		const city        = data[ field ][ prefix + 'oxcity' ];
		const country     = data[ field ][ prefix + 'oxcountryid' ];
		const address     = data[ field ][ prefix + 'oxstreet' ];
		const address2    = '';
		const housenumber = data[ field ][ prefix + 'oxstreetnr' ];

		return {
			type,
			email,
			persontitle,
			firstname,
			lastname,
			birthday,
			zipcode,
			city,
			country,
			address,
			address2,
			housenumber,
		};
	}

	signal = null;

	#sendRequest() {

		const CANCELLED = 'CANCELLED';

		// Return Promise that will get resolved, when the fetch resolves.
		return new Promise( (resolve, reject) => {

			// Get formdata.
			const formData = new URLSearchParams( this.getFormData() );

			// Abort previous call, if not completed yet.
			if ( this.fetchController ) {
				// Formbound Controller, so only one fetch gets called at a time.
				this.fetchController.abort( CANCELLED );
			}
			this.fetchController = new AbortController();
			const signal = this.fetchController.signal;

			return fetch(
				'/index.php?cl=user&fnc=verifyAddress',
				{
					method: 'POST',
					body: formData,
					signal
				})
				.then( res => res.json() )
				.then( res => resolve( res ) )
				.catch( err => {

					// Do not resolve this promise at all because it was cancelled.
					if ( CANCELLED === err ) {
						return null;
					}

					// Some error happened on serverside - reject this request
					console.error( err );
					resolve( { status: 'NOK' } );
				}).finally( () => {
					// Reset fetchController because the fetch completed.
					this.fetchController = null;
				});
		} );
	}

	static getInstance( fieldsetEl ) {
		fieldsetEl.ACL_VERIFY_ADDRESS ??= new VerifyAdressClass( fieldsetEl );
		return fieldsetEl.ACL_VERIFY_ADDRESS;
	}

	static verifyAddress = ( fieldsetEls, force = false ) => {
		const promises = Array.from( $( fieldsetEls ) ).map( fieldsetEl => {
			return VerifyAdressClass.getInstance( fieldsetEl ).verify( force );
		} );
		return asyncValidateAll( promises );
	};
}

const initAddressForm = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( '.verifyaddress' ).forEach( fieldsetEl => {
		VerifyAdressClass.getInstance( fieldsetEl );
	});
};

// Init.
document.addEventListener( 'init_forms.acl', () => initAddressForm() );

// Expose.
window.checkaddress = VerifyAdressClass.verifyAddress;

// Export.
const verifyAddress = VerifyAdressClass.verifyAddress;
export {
	verifyAddress as default,
	initAddressForm,
	VerifyAdressClass
};
